import React from 'react';
import { Link } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext';

const Toast = () => {
  const { toasts, removeToast } = useToast();

  const getToastStyle = (type) => {
    const baseStyle = {
      padding: '1rem',
      borderRadius: '0.5rem',
      marginBottom: '0.5rem',
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      maxWidth: '28rem',
    };

    const typeStyles = {
      success: { backgroundColor: '#22C55E', color: 'white' },
      error: { backgroundColor: '#EF4444', color: 'white' },
      info: { backgroundColor: 'var(--theme-primary)', color: 'var(--theme-button-text)' },
      warning: { backgroundColor: '#F59E0B', color: 'white' },
    };

    return { ...baseStyle, ...typeStyles[type] };
  };

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '1rem',
        right: '1rem',
        zIndex: 9999,
      }}
    >
      {toasts.map((toast) => (
        <div key={toast.id} style={getToastStyle(toast.type)}>
          <div style={{ minWidth: 0 }}>
            <div style={toast.detail ? { fontWeight: 600 } : undefined}>{toast.message}</div>
            {toast.detail && (
              <div
                style={{
                  marginTop: '0.35rem',
                  fontSize: '0.75rem',
                  lineHeight: 1.4,
                  opacity: 0.9,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  maxHeight: '12rem',
                  overflow: 'auto',
                }}
              >
                {toast.detail}
              </div>
            )}
            {toast.link && (
              <Link
                to={toast.link}
                onClick={() => removeToast(toast.id)}
                style={{
                  display: 'inline-block',
                  marginTop: '0.5rem',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textDecoration: 'underline',
                  color: 'inherit',
                }}
              >
                {toast.linkLabel || 'Go to billing'}
              </Link>
            )}
          </div>
          <button
            onClick={() => removeToast(toast.id)}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'inherit',
              cursor: 'pointer',
              fontSize: '1.25rem',
              padding: '0',
              marginLeft: '1rem',
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toast;
